module.exports = __webpack_public_path__ + "img/bfmdzs01.571fb3ca.png";